import type { HelpFile } from '../../types/help'
import { DragHandleTestIds } from '../../../testids/DragHandleTestIds'

export const dragHandleHelp: HelpFile = {
  texts: {
    [DragHandleTestIds.dragRow42]:
      'Greifpunkt — diese Zeile ziehen, um sie innerhalb der Liste neu anzuordnen.',
  },
}
